import { useMatches } from "@tanstack/react-router";

/**
 * Returns the active file name to display based on the query param "file".
 * If the URL param is present, it will be used.
 */
export function useActiveFileName(): string | undefined {
  return useMatches({
    select: (matches) => {
      const filesystemMatch = matches.find(
        (match) =>
          match.routeId ===
          "/(codegen)/codegen/$projectId/filesystem/$snapshotId",
      );

      if (!filesystemMatch) {
        return undefined;
      }

      const search = filesystemMatch.search as { file?: string };
      return search.file;
    },
  });
}
